<template>
  <section :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="row px-2">
        <div
          class="col-lg-3 col-12 heading-box d-flex align-items-center justify-content-center p-4"
        >
          <h2>HOW IT WORKS</h2>
        </div>

        <!-- FIND -->
        <div class="col-lg-3 col-12">
          <div class="step-container flex-column">
            <h4>1. FIND</h4>
            <p>Explore our collection of original artwork created by artists from around the globe.</p>
            <router-link
              to="/artists"
              @click.native="resetSearch"
              class="btn btn-outline-primary"
            >SHOP NOW</router-link>
          </div>
        </div>

        <!-- BUY -->
        <div class="col-lg-3 col-12">
          <div class="step-container flex-column">
            <h4>2. BUY</h4>
            <p>Quickly and easily purchase the exclusive artwork of your choice.</p>
          </div>
        </div>

        <!-- USE -->
        <div class="col-lg-3 col-12">
          <div class="step-container flex-column">
            <h4>3. USE</h4>
            <p>Download your high resolution artwork and use it for your next project.</p>
            <router-link
              to="/uses"
              v-if="$route.name != 'Uses'"
              class="btn btn-outline-primary"
            >SEE USES</router-link>
            <base-button v-else type="outline-primary">SEE USES</base-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "how-it-works",
  props: {
    backgroundColor: {
      type: String,
      default: "white",
      description: "Section background color"
    }
  },
  methods: {
    resetSearch() {
      this.$store.commit("setSearchPage", 1);
    }
  }
};
</script>

<style scoped lang="scss">
section {
  padding-top: 4.5rem;
  padding-bottom: 4.5rem;
}
.heading-box {
  background: black;
  border-radius: 4px;
}

h2 {
  font-size: 1.8rem;
  color: white;
}

.number {
  font-weight: 700;
  font-size: 2.875rem;
  color: black;
  line-height: 0.85;
}

.step-container {
  padding-left: 1.5rem;
}

h4 {
  font-size: 1.25rem;
}

@media (max-width: 991.98px) {
  section {
    padding-bottom: 0;
  }

  .heading-box {
    margin-bottom: 3rem;
  }

  h2 {
    margin-bottom: 0;
    padding: 2rem 0;
  }

  .step-container {
    text-align: center;
    margin-bottom: 3rem;
    padding: 0 1.5rem;
  }
}
</style>
